import React from "react";
import { useMessageSource } from "react-message-source";
import CustomTypography from "../../typography";
import { DrawerHeaderProps } from "./types";
import "./styles.scss";

const classNameBase = "scd-language-selection-header";

export const DrawerHeader = (props: DrawerHeaderProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  return (
    <div className={classNameBase}>
      <CustomTypography variant={"h3"} className={`${classNameBase}-text`}>
        {getMessage("Header.language-selection-header")}
      </CustomTypography>
      <i className="icon-scd-close" onClick={props.onClose} />
    </div>
  );
};
